import { useEffect, useState } from "react"
import { getValidatorLogo } from "utils/Helpers";
import { queryValidator } from "utils/RpcHelpers";

type Props = {
    validatorAddress: string
}

export function ValidatorDetailCard({ validatorAddress }: Props) {

    const [validatorInfo, setValidatorInfo] = useState<{ moniker: string, details: string, website: string, securityContact: string }>();


    const loadValidator = async () => {
        const res = await queryValidator(validatorAddress)
        if (res) setValidatorInfo(res.description)
    }

    useEffect(() => {
        loadValidator()
    }, [])

    return <div className="card">
        <div className="card h-100">
            <div className="card-body">
                <div className="row">
                    <div className="col-12 col-md-2">
                        <img className="w-100" src={getValidatorLogo(validatorAddress)} />
                    </div>
                    <div className="col-12 col-md 10">
                        <h3>{validatorInfo?.moniker}</h3>
                        <div className="text-muted">
                            {validatorInfo?.details}
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <a className="btn btn-secondary" href={validatorInfo?.website}>
                            <i className="tf-icons bx bx-world me-1"></i>
                            Visit our website
                        </a>
                        <a className="btn btn-secondary ms-2" href={`mailto:${validatorInfo?.securityContact}`}>
                            <i className="tf-icons bx bx-envelope me-1"></i>
                            Contact Us
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}   